<template>

    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <EntityTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow class="pb-3">
                        <CCol sm="12">
                            <CButton color="primary" @click="create">Создать</CButton>
                        </CCol>
                    </CRow>                    
                    <CRow class="pl-3">
                        <table class="table">
                            <thead>
                                <th></th>
                                <th>Название</th>
                                <th>Вес</th>
                                <th>Количество</th>
                                <th>Стоимость</th>
                                <th>Активен</th>
                                <th></th>
                            </thead>
                            <draggable v-model="options" tag="tbody">
                                <tr v-for="option in options" :key="option.title">
                                    <td><CIcon
                                        :height="24"
                                        :content="$options.icons.cilCursorMove"
                                        class="handle" /></td>
                                    <td>{{ option.title }}</td>
                                    <td>{{ option.weight }}</td>
                                    <td>{{ option.quantity }}</td>
                                    <td>{{ option.price }}</td>
                                    <td>
                                        <CBadge :color="getBadge(option.enabled)">
                                            &nbsp;{{ option.enabled ? 'Да' : 'Нет' }}&nbsp;
                                        </CBadge>
                                    </td>
                                    <td>
                                        <CButton @click="edit(option.id)"><CIcon :content="$options.icons.cilPencil" class="handle" /></CButton>
                                        <CButton @click="removeConfirmation(option.id)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton>
                                    </td>
                                </tr>
                            </draggable>
                        </table>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save">Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack">Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            :title="createEditModalTitle"
            :show.sync="createEditModal.visible"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Название</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.option.title"
                                    placeholder="Название опции"
                                    description="Обязательно для заполнения"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Вес</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.option.weight"
                                    placeholder="Вес"
                                    description="Необязательно для заполнения"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Количество</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.option.quantity"
                                    placeholder="Количество"
                                    description="Необязательно для заполнения"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Стоимость</CCol>
                            <CCol sm="9">
                                <CInput
                                    v-model="createEditModal.option.price"
                                    placeholder="Стоимость опции"
                                    description="Введите 0, если не влияет на стоимость блюда"
                                />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">Активен</CCol>
                            <CCol sm="9">
                                <CSwitch
                                    color="dark"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="createEditModal.option.enabled"
                                />
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="createEditModal.visible = false">Отмена</CButton>
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="createUpdateOption">{{ createEditModalButton }}</CButton>
                </div>
            </template>
        </CModal>

        <CModal
            title="Подтверждение"
            color="danger"
            :show.sync="deleteModal.visible"
            :footer="false">
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <p>Вы действительно хотите удалить опцию? Это действие нельзя будет отменить.</p>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="deleteModal.visible = false">Отмена</CButton>
                    <CButton
                        color="danger"
                        class="ml-3"
                        @click="remove">Удалить</CButton>
                </div>
            </template>
        </CModal>


    </CRow>
</template>

<script>
    import Vue from 'vue';
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash, cilPencil } from '@coreui/icons';
    import EntityTabLinks from '@/components/entities/EntityTabLinks';

    export default {

        name: 'EntityOptions',
  
        components: {
            EntityTabLinks,
            draggable,
        },
  
        data () {
            return {
                entity: {},
                options: [],
                createEditModal: {
                    visible: false,
                    editMode: false,
                    editId:0,
                    option: {
                        entity_id: '',
                        title: '',
                        weight: 0,
                        quantity: 0,
                        price: 0,
                        enabled: false,
                        position: 0
                    }
                },
                deleteModal: {
                    visible: false,
                    optionId: 0
                }
            }
        },
    
        computed: {
            createEditModalTitle: function() {
                return this.createEditModal.editMode ? 'Редактирование опции' : 'Создание опции';
            },
            createEditModalButton: function() {
                return this.createEditModal.editMode ? 'Сохранить' : 'Создать';
            }
        },

        mounted() {
            const id = this.$route.params.id;
            const code = this.$route.params.code;
            Vue.axios.get(`/entities/get/${id}`)
                .then(resp => {
                    this.entity = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
            Vue.axios.get(`/entities/${code}/get-options/${id}`)
                .then(resp => {
                    this.options = resp.data;
                })
                .catch(() => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        icons: {
            cilCursorMove,
            cilTrash,
            cilPencil
        },

        methods: {

            create() {
                this.createEditModal.editMode = false;
                this.createEditModal.option.title = '';
                this.createEditModal.option.weight = 0;
                this.createEditModal.option.quantity = 0;
                this.createEditModal.option.price = 0;
                this.createEditModal.option.enabled = true;
                this.createEditModal.visible = true;
            },

            createUpdateOption() {
            
                if(!this.createEditModal.option.title) {
                    this.$root.$emit('showError', 'Название опции является обязательным.');
                    return;
                }
                if(this.createEditModal.option.price === null) {
                    this.$root.$emit('showError', 'Стоимость является обязательной для заполнения.');
                    return;
                }
                if(!this.createEditModal.option.weight) {
                    this.createEditModal.option.weight = 0;
                }
                if(!this.createEditModal.option.quantity) {
                    this.createEditModal.option.quantity = 0;
                }

                if(this.createEditModal.editMode) {
                    Vue.axios.post(
                        `/entities/${this.$route.params.code}/options/${this.entity.id}/update/${this.createEditModal.editId}`,
                        this.createEditModal.option)
                        .then(resp => {
                            const justUpdated = resp.data;
                            const _options = this.options.slice();
                            for(var i = 0; i < _options.length; i++) {
                                if(_options[i].id === justUpdated.id) {
                                    _options[i] = justUpdated;
                                }
                            }
                            this.options = _options;
                            this.createEditModal.visible = false;
                        })
                        .catch(() => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                } else {
                    Vue.axios.post(`/entities/${this.$route.params.code}/options/${this.$route.params.id}/create`, this.createEditModal.option)
                        .then(resp => {
                            const justCreated = resp.data;
                            const _options = this.options.slice();
                            _options.push(justCreated);
                            this.options = _options;
                            this.createEditModal.visible = false;
                        })
                        .catch(() => {
                            this.$root.$emit('showError', 'Ошибка сохранения.');
                        });
                }
            },

            edit(id) {
                this.createEditModal.editId = id;
                this.createEditModal.editMode = true;
            
                var _option = {};
                for(var i = 0; i < this.options.length; i++) {
                    if(this.options[i].id === id) {
                        _option = this.options[i];
                    }
                }

                this.createEditModal.option.title = _option.title,
                this.createEditModal.option.weight = _option.weight;
                this.createEditModal.option.quantity = _option.quantity;
                this.createEditModal.option.price = _option.price;
                this.createEditModal.option.enabled = _option.enabled;
                this.createEditModal.option.position = _option.position;
            
                this.createEditModal.visible = true;
            },

            save() {
                // Save order only
                const reorder = [];
                let index = 0;
                this.options.forEach(option => {
                    reorder.push({
                        id: option.id,
                        position: ++index
                    });
                });
                Vue.axios.post(`/entities/${this.$route.params.code}/options/${this.$route.params.id}/reorder`, { reorder })
                    .then(() => {
                        this.$router.push(`/entities/${this.$route.params.code}/${this.$route.params.id}`)
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },

            removeConfirmation(id) {
                this.deleteModal.optionId = id;
                this.deleteModal.visible = true;
            },

            remove() {
                const id = this.deleteModal.optionId;
                Vue.axios.delete(`/entities/${this.$route.params.code}/options/${this.$route.params.id}/${id}`)
                    .then(() => {
                        const _options = []; 
                        for(var i = 0; i < this.options.length; i++) {
                            if(id != this.options[i].id) {
                                _options.push(this.options[i]);
                            }
                        }
                        this.options = _options;
                        this.deleteModal.visible = false;
                    })
                    .catch(() => {
                        this.$root.$emit('showError', 'Ошибка удаления.');
                    });
            },

            goBack() {
                this.$router.push({ path: `/entities/${this.$route.params.code}/${this.$route.params.id}` })
            },

            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
        }
    }

</script>
<style scoped>
.handle {
  cursor: pointer;
}
</style>
